// extracted by mini-css-extract-plugin
export default {"grid__container":"uwUHH","column-margin":"EhT8R","column":"U6iei","grid__item":"m3OnV"};